import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import 'react';
import { usePopoverContext } from './context.js';
import { jsx } from '@emotion/react';
import '@indeed/ihl-use-id';

const PopoverTrigger = props => {
  const {
    getTriggerProps
  } = usePopoverContext();
  return jsx("button", _extends({
    "aria-haspopup": "dialog",
    type: "button"
  }, getTriggerProps(), props));
};
PopoverTrigger.displayName = "PopoverTrigger";

export { PopoverTrigger };
